<template>
  <v-row>
    <v-col
      v-for="(item, i) in items"
      :key="i"
      cols="12"
      sm="6"
      lg="3"
    >
      <v-card>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-subtitle class="subtitle-1" v-text="item.name"></v-card-subtitle>
            <v-card-title
              class="headline font-weight-bold mt-2"
              v-text="item.title"
            >
            </v-card-title>
          </div>
          <div class="circle3 mr-4 mt-6" :style="{'background-image': 'url(' + item.src + ')'}"></div>
          <!--<v-avatar class="mr-3 mt-10" :color="`${item.color} lighten-5`">
            <v-icon :color="item.color" v-text="item.icon"></v-icon>
          </v-avatar>-->
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Farmers Challenges
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="bar"
            height="390"
            :options="chartOptionsa"
            :series="seriesa"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Insured Farmers
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="570"
            :options="chartOptionsj"
            :series="seriesj"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Livestock Farmers
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="bar"
            height="410"
            :options="chartOptionsb"
            :series="seriesb"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Crop Farmers
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="bar"
            height="410"
            :options="chartOptionsc"
            :series="seriesc"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Source of Input
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="445"
            :options="chartOptionsd"
            :series="seriesd"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Market Type
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="441"
            :options="chartOptionse"
            :series="seriese"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Source of Funding
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="475"
            :options="chartOptionsf"
            :series="seriesf"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Farming Type
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="445"
            :options="chartOptionsg"
            :series="seriesg"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Processing type
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="445"
            :options="chartOptionsh"
            :series="seriesh"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-card>
        <div>
          <v-card-title
            class="headline font-weight-bold"
          >
            Supported Farmers(2180)
          </v-card-title>
        </div>
        <div v-if="showChart">
          <apexchart
            type="donut"
            width="490"
            :options="chartOptionsi"
            :series="seriesi"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      showChart: false,
      /* items: [
        {
          name: 'Farmers',
          title: '283,082',
          color: 'orange',
          icon: 'mdi-account-group',
          src: require('@/assets/icons/malefarmer.png')
        },
        {
          name: 'Male Farmers',
          title: '157,851',
          color: 'blue',
          icon: 'mdi-home-group'
        },
        {
          name: 'Female Farmers',
          title: '125,231',
          color: 'red',
          icon: 'mdi-currency-ngn'
        },
        {
          name: 'Farm land Mapped(Ha)',
          title: '4350',
          color: 'red',
          icon: 'mdi-currency-ngn'
        }
      ], */
      items: [
        {
          name: 'Registered Farmers',
          title: '283,082',
          color: 'orange',
          src: require('@/assets/icons/groupfarmer.png')
        },
        {
          name: 'Male Farmers',
          title: '157,851',
          color: 'blue',
          src: require('@/assets/icons/malefarmer.png')
        },
        {
          name: 'Female Farmers',
          title: '125,231',
          color: 'red',
          src: require('@/assets/icons/femalefarmer.png')
        },
        {
          name: 'Farm land Mapped(Ha)',
          title: '4350',
          color: 'red',
          src: require('@/assets/icons/land.png')
        }
      ],
      seriesa: [{
        data: [
          57619, 187344, 136867, 231050, 76102, 108079, 125145, 26955, 54276, 56873
        ]
      }],
      chartOptionsa: {
        chart: {
          height: 350,
          type: 'bar',
          events: {
            click: function (chart, w, e) {
            // console.log(chart, w, e)
            }
          }
        },
        colors: ['#FF5260'],
        plotOptions: {
          bar: {
            columnWidth: '40%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [
            'Lack of Land', 'Lack of Fertilizer', 'Lack of Improved inputs', 'Lack of Funds', 'Lack of Market Access',
            'Pest', 'Lack of Training', 'Weather', 'Transportation', 'Cost of Inputs'
          ],
          labels: {
            style: {
            // colors: ['#9GF654'],
              fontSize: '12px'
            }
          }
        }
      },
      seriesb: [{
        data: [
          24739, 1149, 1270, 14081, 35518, 7114, 371
        ]
      }],
      chartOptionsb: {
        chart: {
          height: 350,
          type: 'bar',
          events: {
            click: function (chart, w, e) {
            // console.log(chart, w, e)
            }
          }
        },
        colors: ['#1dc254'],
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [
            'Goat', 'Cattle', 'Sheep', 'Pig', 'Poultry', 'Fish', 'Snail'
          ],
          labels: {
            style: {
            // colors: ['#9GF654'],
              fontSize: '12px'
            }
          }
        }
      },
      seriesc: [{
        data: [
          2368, 15574, 190996, 28807, 21351, 11433, 21732
        ]
      }],
      chartOptionsc: {
        chart: {
          height: 350,
          type: 'bar',
          events: {
            click: function (chart, w, e) {
            // console.log(chart, w, e)
            }
          }
        },
        colors: ['#1dc254'],
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [
            'Rice', 'Yam', 'Cassava', 'Oil Palm', 'Maize', 'Plantain', 'Vegetable'
          ],
          labels: {
            style: {
            // colors: ['#9GF654'],
              fontSize: '12px'
            }
          }
        }
      },
      seriesd: [220835, 15350],
      chartOptionsd: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Open Market', 'Govt. Agency']
      },
      seriese: [70695, 197409, 24925],
      chartOptionse: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Farm Gate', 'Local Market', 'Inter State']
      },
      seriesf: [1436, 3001, 233102],
      chartOptionsf: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Bank Loan', 'Cooperative', 'Personal Savings']
      },
      seriesg: [178310, 63146],
      chartOptionsg: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Commercial', 'Subsistence']
      },
      seriesh: [154969, 110606],
      chartOptionsh: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Commercial', 'Self']
      },
      seriesi: [2180, 750, 52, 102],
      chartOptionsi: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['Trained', 'Improved Inputs', 'Financial Aid', 'Connected to Market']
      },
      seriesj: [280465, 2617],
      chartOptionsj: {
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 420,
          options: {
            chart: {
              width: 350
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        labels: ['No Insurance', 'Has Insurance']
      }
    }
  },
  mounted () {
    this.showChart = true
  }
}
</script>

<style lang="scss" scoped>
.circle2 {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: #0D8134;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle3 {
  border-radius: 50%;
  border: 3px solid  #0D8134;
  width: 80px;
  height: 80px;
  background-position: center;
  background-size: 80px;
}
.v-main{
  height: 100%
}
</style>
